// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__GM21U","isActive":"styles_isActive__uVYXL","edit":"styles_edit__7fk5b","icon":"styles_icon__mhRMi","link":"styles_link__kp7ND"};